module.exports = __webpack_public_path__ + "static/media/play-in-circle-filled.0bc28956.svg";